/**
 * @description All Events will be written inside this file. Format for this event are as follows
 */

const Events = {
  Employee: {
    Module: 'Employees',
    Screen: {
      Issues: {
        Name: 'Issues',
        Events: {
          Filter_Click: 'FilterClick',
          Add_Issue_Click: 'Add_IssueClick',
          Save_Issue_Click: 'Save_IssueClick',
          Close_Issue_Click: 'Close_IssueClick',
          Download_Click: 'DownloadClick',
          Search_Click: 'SearchClick'
        }
      },
      Feedback: {
        Name: 'Feedback',
        Events: {
          Filter_Click: 'FilterClick',
          Add_Feedback_Click: 'Add_FeedbackClick',
          Save_Feedback_Click: 'Save_FeedbackClick',
          Close_Feedback_Click: 'Close_FeedbackClick',
          Download_Click: 'DownloadClick',
          Search_Click: 'SearchClick'
        }
      },
      Stoplights: {
        Name: 'Stoplight',
        Events: {
          Filter_Click: 'FilterClick',
          Add_Stoplight_Click: 'Add_StoplightClick',
          Save_Stoplight_Click: 'Save_StoplightClick',
          Close_Stoplight_Click: 'Close_StoplightClick',
          Download_Click: 'DownloadClick',
          Search_Click: 'SearchClick'
        }
      },
      // TODO: Deprecated events
      // List: {
      //   Name: 'List',
      //   Events: {
      //     ToDo_Click: 'To_DoClick',
      //     Completed_Click: 'CompletedClick',
      //     NewHires_Click: 'New_HiresClick',
      //     Search_Click: 'SearchClick'
      //   }
      // },
      DirectReports: {
        Name: 'Direct Reports',
        Events: {
          HCA_Colleagues_Click: 'HCA_ColleaguesClick',
          ToDo_Click: 'To_DoClick',
          Completed_Click: 'CompletedClick',
          New_Hires_Click: 'New_HiresClick',
          Search_Click: 'SearchClick',
          Direct_Reports_List_Click: 'Direct_Reports_ListClick',
          List_Dropdown_Click: 'List_DropdownClick'
        }
      },
      Delegate: {
        Name: 'Delegate',
        Events: {
          HCA_Colleagues_Click: 'HCA_ColleaguesClick',
          ToDo_Click: 'To_DoClick',
          Completed_Click: 'CompletedClick',
          New_Hires_Click: 'New_HiresClick',
          Search_Click: 'SearchClick',
          Delegate_List_Click: 'Delegate_ListClick',
          List_Dropdown_Click: 'List_DropdownClick'
        }
      },
      Adhoc: {
        Name: 'Adhoc',
        Events: {
          Search_Click: 'Search_Click',
          AdHoc_List_Click: 'AdHoc_ListClick',
          Search_All_Employees_Click: 'Search_All_EmployeesClick'
        }
      },
      Profile: {
        Name: 'Employee Profile',
        Events: {
          Notes_Click: 'NotesClick',
          Save_Notes_Click: 'Save_NotesClick',
          Past_Rounds_Click: 'Past_RoundsClick',
          Past_Issues_Click: 'Past_IssuesClick',
          Past_Feedback_Click: 'Past_FeedbackClick',
          Start_a_New_Round_Click: 'Start_a_New_RoundClick',
          Complete_Round_Click: 'Complete_RoundClick',
          Cancel_Round_Click: 'Cancel_RoundClick',
          Calendar_Click: 'CalendarClick'
        }
      }
    }
  },
  Patient: {
    Module: 'Patients',
    Screen: {
      Issues: {
        Name: 'Issues',
        Events: {
          Filter_Click: 'FilterClick',
          Add_Issue_Click: 'Add_IssueClick',
          Save_Issue_Click: 'Save_IssueClick',
          Close_Issue_Click: 'Close_IssueClick',
          Download_Click: 'DownloadClick',
          Search_Click: 'SearchClick'
        }
      },
      Feedback: {
        Name: 'Feedback',
        Events: {
          Filter_Click: 'FilterClick',
          Add_Feedback_Click: 'Add_FeedbackClick',
          Save_Feedback_Click: 'Save_FeedbackClick',
          Close_Feedback_Click: 'Close_FeedbackClick',
          Download_Click: 'DownloadClick',
          Search_Click: 'SearchClick'
        }
      },
      Stoplights: {
        Name: 'Stoplight',
        Events: {
          Filter_Click: 'FilterClick',
          Add_Stoplight_Click: 'Add_StoplightClick',
          Save_Stoplight_Click: 'Save_StoplightClick',
          Close_Stoplight_Click: 'Close_StoplightClick',
          Download_Click: 'DownloadClick',
          Search_Click: 'SearchClick'
        }
      },
      Census: {
        Name: 'Census',
        Events: {
          ToDo_Click: 'To_DoClick',
          Completed_Click: 'CompletedClick',
          Search_Click: 'SearchClick',
          Patient_Census_List_Click: 'Patient_Census_ListClick'
        }
      },
      Profile: {
        Name: 'Patient Profile',
        Events: {
          Notes_Click: 'NotesClick',
          SaveNotes_Click: 'Save_NotesClick',
          Past_Rounds_Click: 'Past_RoundsClick',
          Past_Issues_Click: 'Past_IssuesClick',
          Past_Feedback_Click: 'Past_FeedbackClick',
          Start_a_New_Round_Click: 'Start_a_New_RoundClick',
          Complete_Round_Click: 'Complete_RoundClick',
          Cancel_Round_Click: 'Cancel_RoundClick',
          Yesterday_Click: 'YesterdayClick'
        }
      }
    }
  },
  CSRN: {
    Module: 'Clinical Support Rounding',
    Screen: {
      List: {
        Name: 'CSRN List',
        Events: {
          CSRN_All_Click: 'CSRN_AllClick',
          No_Round_Click: 'No_RoundClick',
          Recently_Completed_Click: 'Recently_CompletedClick',
          New_Nurses_Click: 'New_NursesClick',
          New_to_HCA_Nurses_Click: 'New_to_HCA_NursesClick',
          New_to_Dept_Nurses_Click: 'New_to_Dept_NursesClick',
          Search_Click: 'SearchClick',
          CSRN_List_Click: 'CSRN_ListClick'
        }
      },
      Issues: {
        Name: 'Issues',
        Events: {
          Filter_Click: 'FilterClick',
          Add_Issue_Click: 'Add_IssueClick',
          Save_Issue_Click: 'Save_IssueClick',
          Close_Issue_Click: 'Close_IssueClick',
          Download_Click: 'DownloadClick',
          Search_Click: 'SearchClick'
        }
      },
      Feedback: {
        Name: 'Feedback',
        Events: {
          Filter_Click: 'FilterClick',
          Add_Feedback_Click: 'Add_FeedbackClick',
          Save_Feedback_Click: 'Save_FeedbackClick',
          Close_Feedback_Click: 'Close_FeedbackClick',
          Download_Click: 'DownloadClick',
          Search_Click: 'SearchClick'
        }
      },
      Profile: {
        Name: 'Employee Profile',
        Events: {
          Notes_Click: 'NotesClick',
          SaveNotes_Click: 'Save_NotesClick',
          Past_Rounds_Click: 'Past_RoundsClick',
          Start_a_New_Round_Click: 'Start_a_New_RoundClick',
          Complete_Round_Click: 'Complete_RoundClick',
          Cancel_Round_Click: 'Cancel_RoundClick',
          Calendar_Click: 'CalendarClick'
        }
      }
    }
  },
  CNEd: {
    Module: 'Clinical Nurse Educator',
    Screen: {
      List: {
        Name: 'CNEd List',
        Events: {
          CNEd_All_Click: 'CNEd_AllClick',
          No_Round_Click: 'No_RoundClick',
          Recently_Completed_Click: 'Recently_CompletedClick',
          New_Nurses_Click: 'New_NursesClick',
          New_to_HCA_Nurses_Click: 'New_to_HCA_NursesClick',
          New_to_Dept_Nurses_Click: 'New_to_Dept_NursesClick',
          Search_Click: 'SearchClick',
          CNEd_List_Click: 'CNEd_ListClick'
        }
      },
      Issues: {
        Name: 'Issues',
        Events: {
          Filter_Click: 'FilterClick',
          Add_Issue_Click: 'Add_IssueClick',
          Save_Issue_Click: 'Save_IssueClick',
          Close_Issue_Click: 'Close_IssueClick',
          Download_Click: 'DownloadClick',
          Search_Click: 'SearchClick'
        }
      },
      Feedback: {
        Name: 'Feedback',
        Events: {
          Filter_Click: 'FilterClick',
          Add_Feedback_Click: 'Add_FeedbackClick',
          Save_Feedback_Click: 'Save_FeedbackClick',
          Close_Feedback_Click: 'Close_FeedbackClick',
          Download_Click: 'DownloadClick',
          Search_Click: 'SearchClick'
        }
      },
      Profile: {
        Name: 'Employee Profile',
        Events: {
          Notes_Click: 'NotesClick',
          Save_Notes_Click: 'Save_NotesClick',
          Past_Rounds_Click: 'Past_RoundsClick',
          Start_a_New_Round_Click: 'Start_a_New_RoundClick',
          Complete_Round_Click: 'Complete_RoundClick',
          Cancel_Round_Click: 'Cancel_RoundClick',
          Calendar_Click: 'CalendarClick'
        }
      }
    }
  },
  Validation: {
    Module: 'Validation Rounding',
    Screen: {
      List: {
        Name: 'Validation List',
        Events: {
          Validation_All_Click: 'Validation_AllClick',
          Completed_Click: 'CompletedClick',
          ToDo_Click: 'To_DoClick',
          Expert_Click: 'ExpertClick',
          Competent_Click: 'CompetentClick',
          Developing_Click: 'DevelopingClick',
          Search_Click: 'SearchClick',
          Validation_List_Click: 'Validation_ListClick'
        }
      },
      Profile: {
        Name: 'Employee Profile',
        Events: {
          Notes_Click: 'NotesClick',
          Save_Notes_Click: 'Save_NotesClick',
          Past_Rounds_Click: 'Past_RoundsClick',
          Start_a_New_Round_Click: 'Start_a_New_RoundClick',
          Complete_Round_Click: 'Complete_RoundClick',
          Cancel_Round_Click: 'Cancel_RoundClick',
          Calendar_Click: 'CalendarClick'
        }
      }
    }
  },
  AIDETValidation: {
    Module: 'AIDET Validation Rounding',
    Screen: {
      List: {
        Name: 'AIDET Validation List',
        Events: {
          Validation_All_Click: 'Validation_AllClick',
          Completed_Click: 'CompletedClick',
          ToDo_Click: 'To_DoClick',
          Expert_Click: 'ExpertClick',
          Competent_Click: 'CompetentClick',
          Developing_Click: 'DevelopingClick',
          Search_Click: 'SearchClick',
          Validation_List_Click: 'Validation_ListClick'
        }
      },
      Profile: {
        Name: 'Employee Profile',
        Events: {
          Notes_Click: 'NotesClick',
          Save_Notes_Click: 'Save_NotesClick',
          Past_Rounds_Click: 'Past_RoundsClick',
          Start_a_New_Round_Click: 'Start_a_New_RoundClick',
          Complete_Round_Click: 'Complete_RoundClick',
          Cancel_Round_Click: 'Cancel_RoundClick',
          Calendar_Click: 'CalendarClick'
        }
      }
    }
  },
  BSSRValidation: {
    Module: 'BSSR Validation Rounding',
    Screen: {
      List: {
        Name: 'BSSR Validation List',
        Events: {
          Validation_All_Click: 'Validation_AllClick',
          Completed_Click: 'CompletedClick',
          ToDo_Click: 'To_DoClick',
          Expert_Click: 'ExpertClick',
          Competent_Click: 'CompetentClick',
          Developing_Click: 'DevelopingClick',
          Search_Click: 'SearchClick',
          Validation_List_Click: 'Validation_ListClick'
        }
      },
      Profile: {
        Name: 'Employee Profile',
        Events: {
          Notes_Click: 'NotesClick',
          Save_Notes_Click: 'Save_NotesClick',
          Past_Rounds_Click: 'Past_RoundsClick',
          Start_a_New_Round_Click: 'Start_a_New_RoundClick',
          Complete_Round_Click: 'Complete_RoundClick',
          Cancel_Round_Click: 'Cancel_RoundClick',
          Calendar_Click: 'CalendarClick'
        }
      }
    }
  },
  Report: {
    Module: 'Reports',
    Screen: {
      Insights: {
        Name: 'HRInsights',
        Events: {
          HR_Insights_Click: 'HR_InsightsClick'
        }
      },
      COG: {
        Name: 'COG Patient Reports',
        Events: {
          COG_Patient_Report_Click: 'COG_Patient_ReportClick'
        }
      },
      EmployeeSummary: {
        Name: 'Employee Summary',
        Events: {
          Compliance_Click: 'ComplianceClick',
          Issue_Click: 'IssueClick',
          Feedback_Recognition_Click: 'Feedback_RecognitionClick',
          Stoplight_Click: 'StoplightClick',
          Feedback_Coaching_Click: 'Feedback_CoachingClick'
        }
      },
      EmployeeCompliance: {
        Name: 'Employee Compliance',
        Events: {
          Date_Range_Click: 'Date_RangeClick',
          Filter_Click: 'FilterClick',
          Info_Click: 'InfoClick',
          Export_CSV_Click: 'Export_CSVClick',
          Location_Dropdown_Click: 'Location_DropdownClick',
          Search_Click: 'SearchClick',
          Download_PDF_Click: 'Download_PDFClick'
        }
      },
      EmployeeRounds: {
        Name: 'Employee Rounds',
        Events: {
          Date_Range_Click: 'Date_RangeClick',
          Filter_Click: 'FilterClick',
          Export_CSV_Click: 'Export_CSVClick',
          Search_Click: 'SearchClick',
          Download_PDF_Click: 'Download_PDFClick'
        }
      },
      EmployeeFreq: {
        Name: 'Employee Frequency',
        Events: {
          Date_Range_Click: 'Date_RangeClick',
          Filter_Click: 'FilterClick',
          Export_CSV_Click: 'Export_CSVClick',
          Search_Click: 'SearchClick',
          Download_PDF_Click: 'Download_PDFClick'
        }
      },
      PatientCompliance: {
        Name: 'Patient Compliance',
        Events: {
          Date_Range_Click: 'Date_RangeClick',
          Info_Click: 'InfoClick',
          Export_CSV_Click: 'Export_CSVClick',
          Location_Dropdown_Click: 'Location_DropdownClick',
          Download_PDF_Click: 'Download_PDFClick'
        }
      },
      PatientRounds: {
        Name: 'Patient Rounds',
        Events: {
          Filter_Click: 'FilterClick',
          Info_Click: 'InfoClick',
          Export_CSV_Click: 'Export_CSVClick',
          Search_Click: 'SearchClick',
          Location_Dropdown_Click: 'Location_DropdownClick',
          Download_PDF_Click: 'Download_PDFClick'
        }
      },
      PatientCensus: {
        Name: 'Patient Census',
        Events: {
          Calendar_Click: 'CalendarClick',
          Info_Click: 'InfoClick',
          Export_CSV_Click: 'Export_CSVClick',
          Search_Click: 'SearchClick',
          Location_Dropdown_Click: 'Location_DropdownClick',
          Download_PDF_Click: 'Download_PDFClick'
        }
      },
      PatientSummary: {
        Name: 'Patient Summary',
        Events: {
          Compliance_Click: 'ComplianceClick',
          Issue_Click: 'IssueClick',
          Feedback_Recognition_Click: 'Feedback_RecognitionClick',
          Stoplight_Click: 'StoplightClick',
          Feedback_Coaching_Click: 'Feedback_CoachingClick'
        }
      }
    }
  },
  Help: {
    Module: 'Help',
    Screen: {
      Sharepoint: {
        Name: 'Orbit Sharepoint Site',
        Events: {
          Orbit_Sharepoint_Site_Click: 'Orbit_SharepointClick'
        }
      },
      HS: {
        Name: 'HealthStream',
        Events: {
          HealthStream_Click: 'HealthStreamClick'
        }
      },
      HR: {
        Name: 'HR Employee Rounding',
        Events: {
          HR_Employee_Rounding_Click: 'HR_Employee_RoundingClick'
        }
      }
    }
  },
  AddNew: {
    Module: 'Add New',
    Screen: {
      AddNewIssue: {
        Name: 'Add New Issue',
        Events: {
          Add_New_Issue_Click: 'Add_New_IssueClick',
          Save_Issue_Click: 'Save_IssueClick',
          Close_Issue_Click: 'Close_IssueClick'
        }
      },
      AddNewFeedback: {
        Name: 'Add New Feedback',
        Events: {
          Add_New_Feedback_Click: 'Add_New_FeedbackClick',
          Save_Feedback_Click: 'Save_FeedbackClick',
          Close_Feedback_Click: 'Close_FeedbackClick'
        }
      },
      AddNewStoplight: {
        Name: 'Add New Stoplight',
        Events: {
          Add_New_Stoplight_Click: 'Add_New_StoplightClick',
          Save_Stoplight_Click: 'Save_StoplightClick',
          Close_Stoplight_Click: 'Close_StoplightClick'
        }
      }
    }
  },
  EmployeeRoundingSettings: {
    Module: 'Employee Rounding Settings',
    Screen: {
      DirectReportsList: {
        Name: 'Direct Reports List',
        Events: { Report_to_GHR_Click: 'Report_to_GHRClick' }
      }
    }
  }
};

export default Events;
